
<template>

	<div>

		<section class="page-banner page-banner-sec">
            <h1 class="section-title" style="">{{ $t('forums.topics') }}</h1>
        </section>

		<div class="card">
            <div class="card-header bg-transparent header-elements-inline">
				<div class="row">
					<div class="col-5">
						<h2 class="card-title"><i class="icon-make-group mr-1"></i>{{ $t('forums.section') }} {{section_title}} </h2>
					</div>
				
					<div class="col-1">
						<button class="btn btn-primary btn-lg btn-block" @click="newTopic" v-b-tooltip :title= getTopicMessage><i class="fa fa-lg fa-plus" aria-hidden="true"></i></button>	
					</div>
					<div class="col-1">
						<button class="btn btn-primary btn-lg btn-block" @click="$router.go(-1)" v-b-tooltip
							title="Back to Forum">{{"Back"}}</button>
					</div>
					<div class="col-5">
					</div>
				
				</div>
					
				
			</div>
		

			<div class="table-responsive">
				<table class="table text-nowrap table-striped table-hover">
					<thead>
						<tr>
							<th><span class="ml-3">{{ $t('forums.select_topic') }}</span></th>
						</tr>
					</thead>
					<tbody data-link="row" class="rowlink">
                		<tr v-for="topic in topics" :key="topic.id">
							<td>
							<router-link :to="{ name: 'post',params: {forum_id: forum_id , section_id: section_id, topic_id:topic.id}, query: {title: topic.title} }">
								<span class="pointer position-relative ml-3">{{topic.title}}</span>
							</router-link>
							</td>
							
						</tr>

					</tbody>
				</table>
				<b-pagination v-if="pagination.total_count > pagination.per_page" size="lg" :total-rows="pagination.total_count" v-model="page" :per-page="pagination.per_page" align="center" class="m-2 mt-4 border bg-light"></b-pagination>
			</div>
		</div>

	</div>

</template>

<script>
// Vuex Stores
import { mapActions, mapGetters } from 'vuex'

// Common OTU Components
import { EventBus, mapNotificationEventActions } from '@/lib/events.js';
import { mapCommonFilters } from '@/lib/filters.js';
import { errHandler, errMessage } from '@/lib/handlers'
import Topic from '@/models/topic';



export default {
	components: {
		// BounceLoader:    () => import ('vue-spinner/src/BounceLoader'),
		// Error:           () => import ('@/components/core/Error')
	},
	 data () {
	 	return {
	 		loaded: false,
	 		error: false,
			page: 1,
			section_title: null,
			forum_id: null,
			section_id: null,
            
	 	}
	},
	watch: {
		'page': {
			 handler () {
				 this.fetchTopics({forumId: this.$route.params.forum_id, sectionId: this.$route.params.section_id, page: this.page, per_page: 20}).then((r) => {
						});
			}
		}
        
	},
	created () {
        this.forum_id = this.$route.params.forum_id;
		this.section_id = this.$route.params.section_id;
        this.section_title = this.$route.query.title ? this.$route.query.title : '';
 		this.fetchTopics({forumId: this.$route.params.forum_id, sectionId: this.$route.params.section_id, page: this.page, per_page: 20}).then((v) => this.loaded = true);
		// if (this.$store.state.forums.forums && this.$store.state.forums.forums[this.$route.params.forum_id]){
		// 		this.section_title =  this.$store.state.forums.forums[this.$route.params.forum_id].sections[this.$route.params.section_id].title;
		// }
		// else {
		// 	//this.section_title = this.$route.params.section_title;
		// }
	},
	computed: {
	   topics () {
         return this.$store.state.forums.topics;
	   },
	   pagination () {
			return this.$store.state.forums.Pagination;
		}
	},
	
methods: {
		...mapActions(['fetchTopics', 'createTopic', 'getSection']),
		...mapNotificationEventActions,
		newTopic () {
			this.$swal({
				title: 'New Topic',
				text: 'Topic Name',
				input: 'text',
				showCancelButton: true,
				confirmButtonText: 'Save',
				showLoaderOnConfirm: true,
  				preConfirm: (title) => {
					let topic = new Topic({title: title});
					 return this.createTopic({forumId: this.$route.params.forum_id, sectionId: this.$route.params.section_id, topic: topic}).catch(err => {
					 	let error = errMessage(err);
					 	this.$swal.showValidationMessage( `Creation failed:<br/>${error}` );
					 })
				}
			});
		},
		getTopicMessage(){
			return this.$t('forums.add_topic')
		}	
    }
}
</script>